// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"121":"vendor","524":"app"}[chunkId] + "." + {"121":"c5c5aeb977c760a07f0f","524":"3c5ed5f7b0353b33e07d"}[chunkId] + ".css";
};